import axios from "axios";
import { toast } from "react-toastify";
import { axiosConfig, ThrowErrorMsg } from "../util";

import {
    GET_CATEGORIES,
    GET_CATEGORIES_PAGINATED,
    ADD_CATEGORY,
    DELETE_CATEGORY,
    GET_CATEGORY,
    UPDATE_CATEGORY
} from "../types";

const basePath = process.env.REACT_APP_API_URL + "/v1";
const basePathPrev = process.env.REACT_APP_API_URL + "/api";

export const getCategories = () => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/categories`);

        dispatch({
            type: GET_CATEGORIES,
            payload: res.data
        });

        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const getPaginateCategories = (query) => async dispatch => {
    try {
        // const res = await axios.get(`${basePath}/categories`, {
        const res = await axios.get(`${basePathPrev}/category/viewAll`, {
            params: query
        });

        dispatch({
            type: GET_CATEGORIES_PAGINATED,
            payload: res.data
        });

        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
}

export const addCategory = data => async dispatch => {
    const body = JSON.stringify(data);

    try {
        const res = await axios.post(`${basePath}/category`, body, axiosConfig);

        dispatch({
            type: ADD_CATEGORY,
            payload: res.data
        });

        return res;
    } catch (err) {
        ThrowErrorMsg(err, dispatch)
    }
};

export const updateCategory = (data, id) => async dispatch => {
    const body = JSON.stringify(data);

    try {
        const res = await axios.put(`${basePath}/category/${id}`, body, axiosConfig);
        
        dispatch({ type: UPDATE_CATEGORY, payload: res.data });
        return res;
        
    } catch (err) {
        ThrowErrorMsg(err, dispatch);
    }
};

export const getCategory = id => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/category/${id}`);

        dispatch({ type: GET_CATEGORY });
        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const deleteCategory = id => async dispatch => {
    try {
        const res = await axios.delete(`${basePath}/category/${id}`);

        dispatch({
            type: DELETE_CATEGORY,
            payload: id
        });

        return res;
    } catch (err) {
        ThrowErrorMsg(err, dispatch)
    }
};

export const getCategoriesUnderGroup = (query) => async dispatch => {
    try {
        let params = {
            ...query,
        }
        const res = await axios.get(`${basePath}/categoriesUnderGroup`, { params }, axiosConfig);
        if (res.status === 200) {
            return res.data;
        } else {
            toast.error(res.data);
            return null;
        }
    } catch (err) {
        ThrowErrorMsg(err);
    }
};